import React from 'react';
import { primaryVolumes, secondaryVolumes, Volume } from '../data/content';
type VolumeGroupProps = {
  title: string;
  subtitle: string;
  volumes: Volume[];
};
function VolumeGroup({
  title,
  subtitle,
  volumes
}: VolumeGroupProps) {
  return <div data-id="element-187" data-mp="kvzprkxqx3gh">
      <div className="flex items-baseline gap-3" data-id="element-188" data-mp="kyc2njoncnmo">
        <h3 className="font-display text-xl font-black tracking-tight text-navy" data-id="element-189" data-mp="pujbplccaf8u">
          {title}
        </h3>
        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-teal" data-id="element-190" data-mp="b5muoysb1rw3">
          {subtitle}
        </span>
      </div>
      <ul className="mt-5 space-y-3" data-id="element-191" data-mp="fz9b921lafx6">
        {volumes.map(volume => <li key={volume.number} className="flex items-start gap-4 rounded-2xl bg-cream px-5 py-4" data-id="element-192" data-mp="27b6t4itp87c">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-white" data-id="element-193" data-mp="3ocycy3whh7z6">
              {volume.number}
            </span>
            <div data-id="element-194" data-mp="3tdvs07m75lwg">
              <h4 className="font-display text-base font-bold text-navy" data-id="element-195" data-mp="3ctnuzb2l89xu">
                {volume.title}
              </h4>
              <p className="mt-1 text-xs leading-relaxed text-navy/55" data-id="element-196" data-mp="37vmduvoq2kp0">
                {volume.text}
              </p>
            </div>
          </li>)}
      </ul>
    </div>;
}
export function WhatsInside() {
  return <section id="contenuto" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-197" data-mp="3htsbv27er6ol">
      <div className="mx-auto max-w-4xl" data-id="element-198" data-mp="2u4hfry1060gs">
        <div className="text-center" data-id="element-199" data-mp="2u121gxf5kvgf">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-200" data-mp="2p54lis7sxr46">
            8 volumi digitali · PDF ad alta risoluzione
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-201" data-mp="32xkv6bv7kne2">
            <span aria-hidden="true" data-id="element-202" data-mp="2aexagxk4jadi">🎼 </span>Cosa trovi dentro il pack{' '}
            <span className="italic text-grape" data-id="element-203" data-mp="26dty4l1abwh1">Matematica Pronta?</span>
          </h2>
        </div>

        <div className="mt-12 grid gap-10 md:grid-cols-2" data-id="element-204" data-mp="9d7jlkpl6eg3">
          <VolumeGroup title="Scuola Primaria" subtitle="5 volumi" volumes={primaryVolumes} data-id="element-205" data-mp="9cobswtnh6fs" />
          <VolumeGroup title="Scuola Secondaria" subtitle="3 volumi" volumes={secondaryVolumes} data-id="element-206" data-mp="j30u0idzsnir" />
        </div>
      </div>
    </section>;
}